/* eslint-disable */
import {
  Button,
  Tag,
  Dropdown,
  Modal,
  message,
  Tooltip,
  Flex,
  Radio,
  Popover,
  Checkbox,
  Space,
} from "antd";
import React, { useEffect, useState, useRef } from "react";

import {
  MenuOutlined,
  ExclamationCircleOutlined,
  SolutionOutlined,
  ToolOutlined,
  SyncOutlined,
  OneToOneOutlined,
  CaretDownOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { CustomTable, CustomTableExtend } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import AddModal from "./component/AddModal";
import ContractorUpdateModal from "./component/UpdateModal";

export default function Contractor() {
  const addModalRef = useRef(null);
  const initTableHead = {
    prop: undefined,
    street: undefined,
    startContractDate: undefined,
    endContractDate: undefined,
    status: undefined,
  };
  const updateModalRef = useRef(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [tableHead, setTableHead] = useState(initTableHead);
  const [options, setOptions] = useState([]);
  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };
  const handleChange = (checkedValues) => {
    console.log(checkedValues);
    setSelectedItems(checkedValues);
    if (childRef.current) {
      childRef.current.toggleColumnVisibility(checkedValues);
    }
  };

  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  const statusList = [
    { value: "", label: "All" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
  ];

  const showModal = () => {
    addModalRef.current?.setModelAdd();
  };

  const handleMenuClick = async (e, record) => {
    if (e.key === "update") {
      console.log("update", updateModalRef);
      updateModalRef.current?.openModal(record);
    }
    if (e.key === "delete") {
      console.log(record);
      Modal.confirm({
        title: "Delete contract",
        icon: <ExclamationCircleOutlined />,
        content: `Are you sure you want to delete the selected data?`,
        okText: "Sure",
        cancelText: "Cancel",
        onOk: async () => {
          const params = {
            id: record.id,
          };
          const response = await http.get(api.getSignaTureDele, { params });
          console.log(response);
          if (response?.code === "1") {
            message.success("Deleted successfully");
            getTableListFn();
          } else {
            message.error(response.msg);
          }
        },
        onCancel() {
          console.log("Cancel");
        },
        style: {
          top: "40%",
        },
      });
    }
  
  };

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "propId",
      hidden: false,
      align: "center",
      width: 80,
      render: (text, record) =>
        (
          commonFn.btnAuthorityFlag("Update") ||
          commonFn.btnAuthorityFlag("Delete")) && (
          <Dropdown
            menu={{
              items: [
            
                commonFn.btnAuthorityFlag("Update") && {
                  key: "update",
                  icon: (
                    <SolutionOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Update</div>,
                },
                commonFn.btnAuthorityFlag("Delete") && {
                  key: "delete",
                  icon: (
                    <ToolOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Delete</div>,
                },
              ],
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>
        ),
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      titleType: "Input",
      width: 200,
      onChange: (e) => tableFilterFn(e, "firstName"),
    },
    {
      title: "status",
      dataIndex: "status",
      titleType: "Select",
      selectOptions: statusList,
      width: 200,
      onChange: (e) => tableFilterFn(e, "status", "Select"),
      // render: (text) => (text === 1 ? "Launch" : text === 0 ? "Remove" : text),
    },

    {
      title: "Url",
      dataIndex: "url",
      width: 200,
      render: (text) => {
        if (!text) return null;

        const handleClick = (e) => {
          e.preventDefault();
          Modal.confirm({
            title: "Notice",
            content: `Do you want to open this external link?\n${text}`,
            okText: "Open",
            cancelText: "Cancel",
            width:"60%",
            onOk: () => window.open(text, "_blank"),
          });
        };

        return (
          <a
            href={text}
            onClick={handleClick}
            title={text}
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
              overflow: "hidden",
              wordBreak: "break-all",
            }}
          >
            {text}
          </a>
        );
      },
    },
    {
      title: "Create Time",
      dataIndex: "createTime",
      titleType: "",
      onChange: (e) =>
        tableFilterFn(
          e,
          ["startExpectedCompleteTimeDate", "endExpectedCompleteTimeDate"],
          "RangePicker",
        ),
      render: (text) => (text ? moment(text).format("MM/DD/YYYY") : ""),
    },
    {
      title: "Update Time",
      dataIndex: "updateTime",
      titleType: "",
      onChange: (e) =>
        tableFilterFn(
          e,
          ["startCommenceDate", "endCommenceDate"],
          "RangePicker",
        ),
      render: (text) => (text ? moment(text).format("MM/DD/YYYY") : ""),
    },
  ];

  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.get(api.getSignaTureList, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
  };

  const handleRoleUpdateSuccess = () => {
    getTableListFn(pagination.current, pagination.pageSize);
  };

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
  }, [refreshKey]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          <Button className="btnNew" onClick={showModal}>
            <PlusOutlined />
            New
          </Button>
        </div>
        <div className="min-width">
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
        rowKey={"id"}
        tableCss="maintenanceTable"
      />

      {/* 新增 */}
      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />
      {/* 修改 */}
      <ContractorUpdateModal
        ref={updateModalRef}
        onSuccess={handleRoleUpdateSuccess}
      />


    </div>
  );
}
